import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { ContentRepositoryToken } from '../../di/tokens';
import type { AddSubjectEdgeInput } from '../../domain/entities/content.entity';

export function useSubjectEdges() {
  const repository = container.resolve(ContentRepositoryToken);
  return useQuery({
    queryKey: ['content', 'edges'],
    queryFn: () => repository.listSubjectEdges(),
    staleTime: 1000 * 60 * 5,
  });
}

function useInvalidateEdges() {
  const queryClient = useQueryClient();
  return () =>
    void queryClient.invalidateQueries({ queryKey: ['content', 'edges'] });
}

export function useAddSubjectEdge() {
  const repository = container.resolve(ContentRepositoryToken);
  const invalidate = useInvalidateEdges();
  return useMutation({
    mutationFn: (input: AddSubjectEdgeInput) =>
      repository.addSubjectEdge(input),
    onSuccess: invalidate,
  });
}

export function useRemoveSubjectEdge() {
  const repository = container.resolve(ContentRepositoryToken);
  const invalidate = useInvalidateEdges();
  return useMutation({
    mutationFn: (vars: { parentId: string; childId: string }) =>
      repository.removeSubjectEdge(vars.parentId, vars.childId),
    onSuccess: invalidate,
  });
}
